export type Rating = 'good' | 'partial' | 'bad'

export const comparisonColumns = [
  { id: 'scaled', label: 'Zu schnell skaliert', note: 'Großes Werbebudget, Founder raus' },
  { id: 'new', label: 'Zu neu am Markt', note: '1–2 Jahre, oft KI-gestützt' },
  { id: 'kraft', label: 'CRM Kraft', note: 'Der Sweet Spot' },
] as const

export const comparisonRows: {
  criterion: string
  values: { text: string; rating: Rating }[]
}[] = [
  {
    criterion: 'Erfahrung mit Close',
    values: [
      { text: 'Viele Projekte', rating: 'good' },
      { text: 'Wenige Projekte', rating: 'bad' },
      { text: '5+ Jahre, 150+ Systeme', rating: 'good' },
    ],
  },
  {
    criterion: 'Founder involviert',
    values: [
      { text: 'Meist nicht mehr', rating: 'bad' },
      { text: 'Ja', rating: 'good' },
      { text: 'Ja – fixt Dringendes selbst', rating: 'good' },
    ],
  },
  {
    criterion: 'Fokus',
    values: [
      { text: 'Neukunden & Marketing', rating: 'bad' },
      { text: 'Lernen am Kunden', rating: 'partial' },
      { text: 'Bestandskunden & Empfehlungen', rating: 'good' },
    ],
  },
  {
    criterion: 'Support',
    values: [
      { text: 'Ticketsystem, Wartezeiten', rating: 'bad' },
      { text: 'Hängt an einer Person', rating: 'partial' },
      { text: 'Slack, WhatsApp, Telegram · Mo–So 9–21 Uhr', rating: 'good' },
    ],
  },
  {
    criterion: 'Skalierbare Automatisierungen',
    values: [
      { text: 'Oft Standard', rating: 'partial' },
      { text: 'Brechen bei mehr Leads', rating: 'bad' },
      { text: 'Für Wachstum gebaut', rating: 'good' },
    ],
  },
  {
    criterion: 'Individuelles Setup',
    values: [
      { text: 'Vorlage, schnell fertig', rating: 'bad' },
      { text: 'Uneinheitlich', rating: 'partial' },
      { text: 'Analyse, Report, Abstimmung', rating: 'good' },
    ],
  },
  {
    criterion: 'Proaktive Weiterentwicklung',
    values: [
      { text: 'Nur auf Nachfrage', rating: 'bad' },
      { text: 'Uneinheitlich', rating: 'partial' },
      { text: 'Regelmäßige Vorschläge', rating: 'good' },
    ],
  },
]
